<template>
  <ReviewGroup class="iv-scoring" :tableData="configData">
    <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line iv-m-b-12">评审打分</h1>
    <ul class="iv-enroll-content-ul">
      <li
        @click="onSelectPrize(item, index)"
        class="iv-fs-16 iv-fc-65 iv-m-t-24 iv-pull-left iv-pointer iv-pos-r" 
        :class="{'iv-enroll-active': index === currentIndex, 'iv-disabled': item.disabled}"
        v-for="(item, index) in prizeList" :key="index">
        <IconFont :type="item.type" class="iv-m-r-12"></IconFont>{{item.title}}
      </li>
    </ul>
    <p class="iv-m-t-24 iv-enroll-content-desc iv-fs-16 iv-fc-65">
      <span>打分说明：</span>
      <span v-html="reviewGroupInfo.scoreExplain"></span>
    </p>
    <div class="iv-m-t-24 iv-text-right iv-pos-r" v-if="reportState != '1'">
      <Button type="save" @click="saveInfo('save')">保存</Button>
      <Button type="submit" class="iv-m-l-8" @click="submit">提交打分</Button>
    </div>
    <DragTable
      class="iv-m-t-12 iv-p-b-40"
      noSearch 
      :showPage="false"
      :showSelect="false"
      :showEdit="false"
      :showDelete="false"
      ref="DragTable"
      :immediateForce="true" 
      :columns="columns" 
      :tableData="tableData">
    </DragTable>
  </ReviewGroup>
</template>

<script>
import IconFont from '@/components/iconfont'
import myScoringColumn from './my-scoring-column'
import ReviewGroup from '../components/review-group'
import DragTable from '@/components/drag-table-inline'
import { get, listRound, listScore, saveScore, report } from '../interface/index'
import { getSignUpId } from '@/views/project-declare/sbgl-interface/index.js'

export default {
  data () {
    return {
      tableData: [],
      currentIndex: 0,
      columns: [],
      configData: [],
      dictMap: {}, //数据字典
      reviewGroupInfo: {},//评审组信息
      prizeList: [],
      reportState: '1',
      rankCode: '',
      reviewRoundId: '',
      userId: sessionStorage.getItem('userId')
    }
  },
  async created () {
    // await this.getUserInfo()
    this.userId = this.$decode(sessionStorage.getItem('userId'))
    this.reviewTeamId = this.$decode(this.$route.query.reviewTeamId)
    this.reviewInfoId = this.$decode(this.$route.query.reviewInfoId)
    this.businessCode = this.$decode(this.$route.query.businessCode)
    this.businessId = this.$decode(this.$route.query.businessId)
    this.bizLineCode = this.$decode(this.$route.query.bizLineCode, 'YWX01')
    await this.getRevireGroupInfo()
    //只有定级才会请求数据字典
    if (this.reviewGroupInfo.scoringMethod === 'DFFS03') {
      await this.getCodeTable(this.rankCode)
    }
    if(!this.userId) {
      await this.getUserInfo() //修改
    }else {
      this.getScoreRound()
    }
    // this.getScoreRound()
    this.jumpMap = {
      'BOE_REPORT_LIST': 'projectDetail',
      'BOE_EVENT_INFO': 'activityDetail'
    }
    //以BOE_EVENT_INFO开头的是活动
    if (/^BOE_EVENT_INFO/.test(this.businessCode)) {
      this.jumpMap[this.businessCode] = 'activityDetail'
    }
  },
  provide () {
    return {
      expandParent: async (type, item) => {
        if (type == 'view') {
          // 校验评审对象是否存在
          let data = {}
          if (/^BOE_EVENT_INFO/.test(this.businessCode)) { //活动调单独的接口
            const result = await this.clickViewForActivity(item)
            data = result.data.data
          } else {
            const result = await getSignUpId({ listItemId: item.objectId })
            data = result.data
          }
          if (!data.signUpId) return this.$Message.error('评审对象已改变，未找到该记录！')
          this.$router.push({
            name: this.jumpMap[this.businessCode] || 'appraisingDetail',
            query: {
              objectId: this.$encode(item.objectId),
              type: this.$encode('see'),
              score: this.$encode('score'),
              reviewTeamId: this.$encode(this.reviewTeamId),
              businessCode: this.$encode(this.businessCode),
              reviewRoundId: this.$encode(this.reviewRoundId),
              reviewDetailId: this.$encode(item.reviewDetailId),
              reportState: this.$encode(this.reportState),
              applicationInfoId: this.$encode(item.reviewDetailId),
              backUrl: 'reviewGrade',
              businessId: this.businessId,
              bizLineCode: this.$encode(this.bizLineCode)
            }
          })
        }
      }
    }
  },
  methods: {
    //活动--点击查看详情
    clickViewForActivity (item) {
      return this.$ajax({
        url: 'api-general/module/v2event/personalCenter/application/getSignUpId',
        method: 'get',
        data: {
          listItemId: item.objectId
        }
      })
    },
    getUserInfo () {
      this.$ajax({
        url: 'api-uum/uuminfo/getUserInfo',
        method: 'get',
        data: {}
      }).then(({data}) => {
        this.userInfo = data.data
        sessionStorage.setItem('userId', this.$encode(this.userInfo.userCode))
        // this.userId = this.$decode(sessionStorage.getItem('userId'))
        this.userId = this.$decode(this.userInfo.userCode)
        this.getScoreRound()
      })
    },
    //处理table参数
    getTableData () {
      const tableParams = this.$refs.DragTable.$refs.Table.rebuildData.map(item => ({
        reviewDetailId: item.reviewDetailId,
        reviewScore: item.reviewScore || 0,
        reviewVoteNum: item.reviewVoteNum || 0,
        reviewRank: item.reviewRank,
        reviewOpinion: item.reviewOpinion
      }))
      return tableParams
    },
    //保存
    saveInfo (type) {
      return new Promise((resolve, reject) => {
        const tableParams = this.getTableData()
        saveScore({details: tableParams}).then(({data}) => {
          if (type) {
            this.$Message.success('保存成功')
          }
          resolve()
        })
      })
    },
    //提交打分
    async submit () {
      // const isCanScore = this.getTableData().every(item => (item.reviewScore || item.reviewVoteNum || item.reviewRank))
      // if (!isCanScore) return this.$Message.warning('您有未打分的项')
      await this.saveInfo()
      const reviewDetailIds = this.getTableData().map(item => item.reviewDetailId)
      report({reviewDetailIds: reviewDetailIds}).then(({data}) => {
        this.$Message.success('提交成功')
        this.back()
      })
    },
    //获取评审组信息
    getRevireGroupInfo () {
      return new Promise((resolve, reject) => {
        get({reviewTeamId: this.reviewTeamId}).then(({data}) => {
          this.configData = data.members.map(item => ({
            ...item,
            operateAuthority: item.operateAuthority ? item.operateAuthority.split(',') : []
          }))
          this.reviewGroupInfo = data
          if (this.reviewGroupInfo.scoreExplain) {
            this.reviewGroupInfo.scoreExplain = this.reviewGroupInfo.scoreExplain.replaceAll('\n', '<br />')
          }
          this.rankCode = data.scoreFieldDict
          resolve()
        })
      })
    },
    //获取打分轮次信息
    getScoreRound () {
      listRound({reviewInfoId: this.reviewInfoId, userId: this.userId}).then(({data}) => {
        if (data && data.length) {
          this.prizeList = data.map(item => ({
            ...item,
            title: `我的打分（${item.reviewRoundNum}）`,
            type: 'zg-mzpy'
          }))
          this.reportState = data[0].reportState
          this.getScoreList(data[0].reviewRoundId)
        }
      })
    },
    //根据对应轮次获取打分列表信息
    getScoreList (reviewRoundId) {
      this.reviewRoundId = reviewRoundId
      listScore({userId: this.userId, reviewRoundId}).then(({data}) => {
        this.tableData = data.map(item => ({
          ...item,
          reviewScore: item.reviewScore ? item.reviewScore - 0 : null,
          reviewVoteNum: item.reviewVoteNum ? item.reviewVoteNum - 0 : null
        }))
        this.columns = myScoringColumn.call(this)
      })
    },
    //选择奖项
    onSelectPrize (item, index) {
      if (item.disabled) return
      this.currentIndex = index
      this.reportState = item.reportState
      this.getScoreList(item.reviewRoundId)
    },
    //获取数据字典  
    getCodeTable (code) {
      this.$set(this.dictMap, code, {})
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: this.bizLineCode || 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = {}
          data.data.length && data.data.forEach(item => {
            if (!this.dictMap[code][item.value]) {
              this.dictMap[code][item.value] = item.title
            }
          })
          resolve()
        })
      })
    },
    //返回
    back () {
      this.$router.push({
        name: 'reviewList',
        query: {
          currentPage: this.$route.query.currentPage || 1,
          tabName: this.$route.query.tabName || ''
        }
      })
    }
  },
  components: {
    IconFont,
    DragTable,
    ReviewGroup
  }
}
</script>

<style lang="scss" scoped>
.iv-scoring {
  .iv-enroll-content-ul {
    overflow: hidden;
    li {
      width: 282px;
      padding: 18px 26px;
      border-radius: 16px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      margin-right: 24px;
      .iv-enroll-content-ul-tip {
        position: absolute;
        top: -28px;
        left: 26px;
        color: #FA2900;
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
      &:hover {
        font-weight: bold;
        color: #FA2900 !important;
        border-color: #FA2900;
      }
      &.iv-enroll-active {
        font-weight: bold;
        color: #FA2900 !important;
        border-color: #FA2900;
      }
    }
    .iv-disabled {
      cursor: not-allowed;
      background-color: #F5F7FA !important;
      border-color: rgba(0, 0, 0, 0.15) !important;
      color: rgba($color: #000000, $alpha: 0.25) !important;
      &:hover {
        font-weight: normal !important;
        color: rgba($color: #000000, $alpha: 0.25) !important;
        border-color: rgba(0, 0, 0, 0.15) !important;
      }
    }
  }
  .iv-enroll-content-desc {
    display: flex;
    background-color: #F5F7FA;
    border-radius: 16px;
    padding: 20px 24px;
  }
  .iv-enroll-tip {
    position: absolute;
    top: -24px;
    right: 20px;
    color: #FA2900;
  }
  .iv-en-grey {
    background-color: #F5F7FA !important;
    border-color: rgba(0, 0, 0, 0.15) !important;
    color: rgba($color: #000000, $alpha: 0.25) !important;
  }
}
</style>